import {Component, OnInit, ViewChild} from '@angular/core';
import {GridComponent} from '@syncfusion/ej2-angular-grids';
import {ServiceAppComponent} from '../service-app.component';
import {ServiceAppModels} from 'src/app/models/serviceapp-models';
import {ServiceAppService} from 'src/app/services/service-app.service';
import {SwissSettingsService} from 'src/app/services/swiss-settings.service';
import {MatDialog} from '@angular/material/dialog';
import {ServiceSynchronisationComponent} from '../service-synchronisation/service-synchronisation.component';

@Component({
    selector: 'app-auftraege',
    templateUrl: './auftraege.component.html',
    styleUrls: ['./auftraege.component.scss']
})
export class AuftraegeComponent implements OnInit {

    @ViewChild('gridAuftraege', {static: true}) public grid?: GridComponent;
    public auftragZeilen: ServiceAppModels.SA_AuftragZeile[] = [];
    public sortOptions: object = {columns: [{field: 'datum', direction: 'Descending'}]};
    public swissDatumFormat = {type: 'date', format: 'dd.MM.yyyy'};
    private currAuftragZeile?: ServiceAppModels.SA_AuftragZeile;
    private dbObjekte: ServiceAppModels.SA_Objekt[] = [];

    constructor(
        private saComp: ServiceAppComponent,
        private svcSA: ServiceAppService,
        public dialog: MatDialog,
        private swissSettings: SwissSettingsService) {
    }

    ngOnInit(): void {
        // Hier wird dem Service-App-Service mitgeteilt, dass er diese Funktion dieser Instanz aufrufen kann.
        this.svcSA.registerOrdersFunc(this.refreshGrid.bind(this));
        this.loadJobEntries();
    }

    refreshGrid(): void {
        this.loadJobEntries();
    }

    loadJobEntries(): void {
        // Die Aufträge aus der DB in anschaubare Daten umwandeln
        this.auftragZeilen = [];
        this.dbObjekte = this.svcSA.getDBTermine();
        if (this.dbObjekte.length > 0) {
            this.getGeplanteAuftraege();

            if (this.grid) {
                this.grid.refresh();
                if (this.swissSettings.getWebConfig().debugMode) {
                    console.log('Das Auftrags-Grid wurde aktualisiert...');
                }
            }
        }
    }

    getGeplanteAuftraege(): void {
        const auftraege = this.dbObjekte.filter(x => x.serviceID != null || x.serviceID !== undefined);

        for (const auftrag of auftraege) {
            if (!auftrag.startTime) {
                return;
            }
            const auftragZeile: ServiceAppModels.SA_AuftragZeile = {
                serviceID: auftrag.serviceID,
                datum: auftrag.startTime,
                auftrag: auftrag.objectNumber,
                bezeichnung: auftrag.objDescription,
                kunde: this.svcSA.getAuftragsKundenAdresseZeile(auftrag.objectID),
                anzDokumente: this.svcSA.getAnzahlDokumente(auftrag.serviceID),
                abgeschlossen: auftrag.serviceComplete === 1,
                uploadNoetig: auftrag.modified,
                uebermittelt: auftrag.transmitted
            };
            this.auftragZeilen.push(auftragZeile);
        }
    }

    dataBound(): void {
        if (!this.grid) {
            return;
        }
        this.grid.height = window.innerHeight - 300;
    }

    async startSync(): Promise<void> {
        this.dialog.open(ServiceSynchronisationComponent, {
            disableClose: true,
            width: '700px',
            panelClass: 'swissdefault-dialog-container'
        });
    }

    checkboxChange(args: any): void {
        const currentRowObject: any = this.grid?.getRowObjectFromUID(args.event.target.closest('tr').getAttribute('data-uid'));
        const currentRowData: ServiceAppModels.SA_AuftragZeile = currentRowObject.data;

        /* Array updaten */
        const indexes = this.auftragZeilen?.map((t, idx) => t.serviceID === currentRowData.serviceID ? idx : undefined).filter(Number);
        if (indexes) {
            indexes.forEach(index => {
                this.auftragZeilen[Number(index)].abgeschlossen = args.checked;
            });
        }


        /* Objekt-Array in Indexed-DB speichern */
        const indexes2 = this.dbObjekte.map((o, idx) => o.serviceID === currentRowData.serviceID ? idx : undefined).filter(Number);
        if (indexes2) {
            let value = 0;
            if (args.checked) {
                value = 1;
            }

            indexes2.forEach(index => {
                this.dbObjekte[Number(index)].serviceComplete = value;
                this.dbObjekte[Number(index)].modified = true;
            });
        }

        this.svcSA.setDBTermine(this.dbObjekte);
    }

    public rowSelected(): void {
        // Service-PosID der ausgewählten Zeile ermitteln
        this.currAuftragZeile = (this.grid?.getSelectedRecords()[0] as ServiceAppModels.SA_AuftragZeile);
        if (this.swissSettings.getWebConfig().debugMode) {
            console.log(this.currAuftragZeile);
        }

        // Termin für das "Wieder-Laden" beim App-Start in IndexedDB speichern
        this.svcSA.saveChoosedAppointmentToDB(this.currAuftragZeile.serviceID);

        // Termin für Service-App setzen
        this.svcSA.setTerminByServiceID(this.currAuftragZeile.serviceID);

        // Termin-Informationen neu laden
        this.saComp.reloadAppointmentByServiceID(this.currAuftragZeile.serviceID);

    }

    public rowDeselected(): void {
        this.currAuftragZeile = undefined;
    }

}
